import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/game/storage1.png';
import _imports_1 from '@/assets/images/game/storage2.png';
import _imports_2 from '@/assets/images/game/storage3.png';
import _imports_3 from '@/assets/images/game/storage4.png';
const _withScopeId = n => (_pushScopeId("data-v-94e9988e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "contain"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"center\" data-v-94e9988e><div data-v-94e9988e><img src=\"" + _imports_0 + "\" alt=\"\" draggable=\"false\" data-v-94e9988e><div class=\"name\" data-v-94e9988e>背包</div></div><div class=\"center-margin\" data-v-94e9988e><img src=\"" + _imports_1 + "\" alt=\"\" draggable=\"false\" data-v-94e9988e><div class=\"name\" data-v-94e9988e>排名</div></div><div data-v-94e9988e><img src=\"" + _imports_2 + "\" alt=\"\" draggable=\"false\" data-v-94e9988e><div class=\"name\" data-v-94e9988e>闯关记录</div></div></div>", 1);
const _hoisted_6 = {
  class: "species"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  draggable: "false"
}, null, -1));
import { onMounted, ref, watch } from 'vue';

// 随机选择一张图片

export default {
  __name: 'GameHeader',
  props: {
    headShow: {
      default: true
    },
    turnBack: Function,
    goldCoin: {
      default: Number
    },
    arrangeNum: {
      default: Number
    }
  },
  setup(__props) {
    const props = __props;
    const randomIndex = Math.floor(Math.random() * 20) + 1;
    const currentImage = ref(require(`@/assets/images/headSculpture/Frame${randomIndex}.png`));
    const goldCoinNum = ref(200);
    function goBack() {
      props.turnBack();
    }
    onMounted(() => {
      const goldCoin = localStorage.getItem('goldCoin');
      if (goldCoin !== null) {
        localStorage.setItem('goldCoin', goldCoin);
        goldCoinNum.value = Number(goldCoin);
        return;
      }
      localStorage.setItem('goldCoin', 200);
    });
    watch(() => props.goldCoin, newValue => {
      const goldCoin = localStorage.getItem('goldCoin');
      if (newValue) {
        localStorage.setItem('goldCoin', newValue);
        goldCoinNum.value = props.goldCoin;
        return;
      }
      goldCoinNum.value = Number(goldCoin);
    }, {
      deep: true // 开启深度监听
    });

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("img", {
        class: "header",
        src: currentImage.value,
        alt: "image",
        draggable: "false"
      }, null, 8, _hoisted_3), [[_vShow, __props.headShow]]), _withDirectives(_createElementVNode("img", {
        class: "header clickable",
        src: require(`@/assets/images/game/goBack${__props.arrangeNum === null ? 0 : __props.arrangeNum}.png`),
        alt: "goBack",
        onClick: goBack,
        draggable: "false"
      }, null, 8, _hoisted_4), [[_vShow, !__props.headShow]]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", null, _toDisplayString(goldCoinNum.value), 1)])])]);
    };
  }
};